import { render } from "./NotFound.vue?vue&type=template&id=2249b61e"
const script = {}
script.render = render

export default script